interface ClickOutsideReturn {
  destroy(): void;
}

export default function clickoutside(node: HTMLElement): ClickOutsideReturn {
  const handleClick = (event : MouseEvent) => {
    if (node && !node.contains(event.target as Node) && !event.defaultPrevented) {
      node.dispatchEvent(new CustomEvent("clickoutside", node as unknown as CustomEventInit));
      // console.log("clickoutside handleClick()");
      // event.stopPropagation();
      // event.preventDefault();
    }
  };

  document.addEventListener("click", handleClick, true);

  return {
    destroy() {
      document.removeEventListener("click", handleClick, true);
    },
  };
}
